import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { put, takeLatest, select } from "redux-saga/effects";
import { getUserByToken, getPasswordInfo } from "../curd/auth.crud";
// import { getUserByToken } from "../../../crud/auth.crud";
import * as routerHelpers from "../../../router/RouterHelpers";
const _ = require("lodash");
export const actionTypes = {
  Login: "[Login] Action",
  Logout: "[Logout] Action",
  Register: "[Register] Action",
  UserRequested: "[Request User] Action",
  UserLoaded: "[Load User] Auth API",
  ShowPasswordModal: "[Show Password Modal] Action",
  HidePasswordModal: "[Hide Password Modal] Action",
  CheckPasswordExpiry: "[Check Password Expiry] Action",
};

const initialAuthState = {
  user: undefined,
  authToken: undefined,
  passwordModal: {
    show: false,
    mode: 'notify' // 'notify' or 'force'
  },
};

export const reducer = persistReducer(
  { storage, key: "demo2-auth", whitelist: ["user", "authToken"] },
  (state = initialAuthState, action) => {
    switch (action.type) {
      case actionTypes.Login: {
        const { authToken } = action.payload;

        return { authToken, user: undefined };
      }

      case actionTypes.Register: {
        const { authToken } = action.payload;

        return { authToken, user: undefined };
      }

      case actionTypes.Logout: {
        routerHelpers.forgotLastLocation();
        return initialAuthState;
      }

      case actionTypes.UserLoaded: {
        const { user } = action.payload;

        return { ...state, user };
      }

      case actionTypes.ShowPasswordModal: {
        const { mode } = action.payload;
        return { 
          ...state, 
          passwordModal: { show: true, mode: mode || 'notify' }
        };
      }

      case actionTypes.HidePasswordModal: {
        return { 
          ...state, 
          passwordModal: { show: false, mode: 'notify' }
        };
      }

      default:
        return state;
    }
  }
);

export const actions = {
  login: (authToken) => ({ type: actionTypes.Login, payload: { authToken } }),
  register: (authToken) => ({
    type: actionTypes.Register,
    payload: { authToken },
  }),
  logout: () => ({ type: actionTypes.Logout }),
  requestUser: (user) => ({
    type: actionTypes.UserRequested,
    payload: { user },
  }),
  fulfillUser: (user) => ({ type: actionTypes.UserLoaded, payload: { user } }),
  showPasswordModal: (mode = 'notify') => ({
    type: actionTypes.ShowPasswordModal,
    payload: { mode },
  }),
  hidePasswordModal: () => ({ type: actionTypes.HidePasswordModal }),
  checkPasswordExpiry: () => ({ type: actionTypes.CheckPasswordExpiry }),
};

export function* saga() {
  yield takeLatest(actionTypes.CheckPasswordExpiry, function* checkPasswordExpirySaga() {
    try {
      const passwordResponse = yield getPasswordInfo();
      const passwordData = passwordResponse.data;
      const lastPasswordChangeAt = passwordData?.data?.last_password_change_at;
      
      // Get user ID from current state
      const state = yield select();
      const userId = state.auth?.user?.id;
      
      if (!userId) return;
      
      const requiresPasswordKey = `password-required-${userId}`;
      const currentRequirement = sessionStorage.getItem(requiresPasswordKey);
      let newRequirement = 'false';
      let shouldShowModal = false;
      
      if (lastPasswordChangeAt === null) {
        // User has never changed password since account creation - force change
        newRequirement = 'true';
        shouldShowModal = true; // Always show modal when password is required
      } else if (lastPasswordChangeAt) {
        const lastChangeDate = new Date(lastPasswordChangeAt);
        const now = new Date();
        const monthsDiff = Math.floor((now - lastChangeDate) / (1000 * 60 * 60 * 24 * 30));
        
        if (monthsDiff >= 3) {
          // Force password change for passwords 3+ months old
          newRequirement = 'true';
          shouldShowModal = true; // Always show modal when password is required
        } else {
          // Password is up to date, no change required
          newRequirement = 'false';
          shouldShowModal = false;
        }
      }
      
      // Update session storage with new requirement
      sessionStorage.setItem(requiresPasswordKey, newRequirement);
      
      // Show modal whenever password is required (expired or never changed)
      if (shouldShowModal) {
        yield put(actions.showPasswordModal('force'));
      }
    } catch (error) {
      // Silently handle password check errors
      console.warn('Failed to check password expiry:', error);
    }
  });

  yield takeLatest(actionTypes.Login, function* loginSaga() {
    const urlParameter = new URL(window.location.href).searchParams;

    const { data } = yield getUserByToken(); // Take only data From the request.

    let permission_array = data.data?.roles?.map((obj) => obj?.permissions);
    // alert();
    let flat_permissions = _.flattenDepth(permission_array, 2);

    let unique = flat_permissions.filter(
      (permission, index, array) =>
        array.findIndex((t) => t.id == permission.id) == index
    );

    let obj = {
      ...data.data,
      permissions: unique,
    };

    if (urlParameter.has("page")) {
      setTimeout(() => {
        window.location.href = `https://wiseberryonline.com.au/${urlParameter.get(
          "page"
        )}`;
      }, 2000);
    }

    yield put(actions.fulfillUser(obj));
  });

  yield takeLatest(actionTypes.Register, function* registerSaga() {
    yield put(actions.requestUser());
  });

  // Get logged in users information
  yield takeLatest(actionTypes.UserRequested, function* userRequested({
    payload,
  }) {
    const { data } = yield getUserByToken(); // Take only data From the request.
    let permission_array = data.data.roles?.map((obj) => obj?.permissions);
    // alert();
    let flat_permissions = _.flattenDepth(permission_array, 2);

    let unique = flat_permissions.filter(
      (permission, index, array) =>
        array.findIndex((t) => t.id == permission.id) == index
    );

    let obj = {
      ...data.data,
      permissions: unique,
    };
    yield put(actions.fulfillUser(obj));

    if (payload?.user?.reload) {
      window.location.reload();
    }
  });
}
